// 设置请求头
// application/x-www-form-urlencoded;charset=UTF-8
import axios from 'axios'
import router from '../router'
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.log(error)
    if (error.response) {
      switch (error.response.status) {
        case 401:
          router.replace({
            path: 'Login',
            query: { redirect: router.currentRoute.fullPath }
          })
      }
    }
    return Promise.reject(error.response.data).catch(function (reason) {
      console.log('catch:', reason)
    }) // 返回接口返回的错误信息
  })

axios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.API_ROOT // 'http://localhost:33042'

function getCookie (name) {
  var strCookie = document.cookie // 获取cookie
  var arrCookie = strCookie.split(';')
  for (let i = 0; i < arrCookie.length; i++) {
    var arr = arrCookie[i].split('=')
    if (arr[0].trim() === name) {
      return arr[1]
    }
  }
  return ''
}

export default {
  get (url) {
    url = url + '?_=' + Math.random()
    var token = getCookie('token')
    return new Promise((resolve, reject) => {
      axios.get(url, { headers: { 'RequestVerificationToken': token } }).then(response => {
        resolve(response)
      })
    })
    // return new Promise((resolve, reject) => {
    //   axios.get(`/CloudParkAPI/Home/TokenHeaderValue`, { headers: { 'RequestVerificationToken': token } }).then(res => {
    //     if (res.status === 200) {
    //       localStorage.setItem('token', res.data)
    //       axios.get(url, { headers: { 'RequestVerificationToken': res.data } }).then(response => {
    //         resolve(response)
    //       })
    //     }
    //   })
    // })
  },
  post (url, data) {
    url = url + '?_=' + Math.random()
    var token = getCookie('token')
    return new Promise((resolve, reject) => {
      axios.post(url, data, { headers: { 'RequestVerificationToken': token } }).then(response => {
        resolve(response)
      })
    })
  },
  download (url, data) {
    url = url + '?_=' + Math.random()
    var token = getCookie('token')
    return new Promise((resolve, reject) => {
      axios.post(url, data, {responseType: 'blob', headers: { 'RequestVerificationToken': token }}).then(response => {
        resolve(response)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js